import { MessageTypes } from 'ReduxStore/message';
import { subscriptionInitialStateType, MessageInterface } from './Interface';
import { SubscriptionTypes, SUbscriptionTypeAction } from './Types';

const initialState: subscriptionInitialStateType = {
	isLoading: false,
	isBilled: false,
};

export const subscriptionReducer = (state = initialState, action: SUbscriptionTypeAction) => {
	switch (action.type) {
		case SubscriptionTypes.CREATE_SUBSCRIPTION:
			return {
				...state,
				isLoading: false,
				isBilled: true,
			};
		case SubscriptionTypes.CANCEL_SUBSCRIPTION:
			return {
				...state,
				isLoading: false,
				isBilled: true,
				message: action.payload,
			};
		case SubscriptionTypes.CHANGE_STATUS:
			return {
				...state,
				isBilled: false,
			};
		case SubscriptionTypes.Errors:
			// eslint-disable-next-line no-console
			console.log(action.payload.errors);
			return {
				...state,
				isBilled: false,
				errors: action.payload.errors,
			};
		default:
			return state;
	}
};
